import HBIcon from "@/components/HBIcon";
import classNames from "classnames";
import styles from "./index.module.less";

export function VipTab({ conf, currentVip, setCurrentVip, disabled }) {
  return (
    <div
      className={classNames(styles.tab, {
        [styles.disabled]: disabled,
      })}
    >
      <div
        className={classNames(styles.personal, {
          [styles.active]: currentVip === "personal",
        })}
        onClick={() => !disabled && setCurrentVip("personal")}
        data-gd-click="button_click"
        data-button-name={conf.personal.tabTitle}
      >
        <span>{conf.personal.tabTitle}</span>
        <span>{conf.personal.tabSubTitle}</span>

        <HBIcon type="arrow_right_circle_fill" />
      </div>
      <div
        className={classNames(styles.company, {
          [styles.active]: currentVip === "company",
        })}
        onClick={() => !disabled && setCurrentVip("company")}
        data-gd-click="button_click"
        data-button-name={conf.company.tabTitle}
      >
        <span>{conf.company.tabTitle}</span>
        <span>{conf.company.tabSubTitle}</span>
        <HBIcon type="arrow_right_circle_fill" />
        <a
          className={styles.consult}
          href="/vip/consult?leads_entrance=I3NThF9VT"
          target="_blank"
        >
          <HBIcon className={styles.icon} type="ic_severice" />
          <div className={styles.text}>企业咨询</div>
        </a>
      </div>
    </div>
  );
}
